export const PRODUCT_REVIEW_MAX_LENGTH = 5000
